import React from 'react';
import {
  Enterprise,
  EntityWithDecisionsToShow,
} from '../../entity/entity.types';
import { EnterpriseList } from '../../entity/entity-lists/EnterpriseList';
import { EntityModalLoader } from '../../components/entity-modal-placeholder/EntityModalLoader';
import { fetchLawFirmEnterprises } from '../../law-firm/lawFirm.api';
import {
  ModalScrollableHeader,
  ModalScrollableContent,
  ModalScrollableContainer,
} from '../../components/modal';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { EntityDecisionListModalWithGoBack } from './EntityDecisionListModalWithGoBack';

type Props = {
  wording: string;
  lawOfficeIdGroup: string;
  source: string;
  name: string;
  onRequestClose: () => void;
  isOpen: boolean;
};

type State = {
  allEnterprises: Enterprise[];
  isLoading: boolean;
  entityWithDecisionsToShowInfos: EntityWithDecisionsToShow | null;
};

export class AllLawFirmEnterprisesModal extends React.Component<Props, State> {
  static defaultProps = {
    onRequestClose: () => {},
    isOpen: false,
  };

  state: State = {
    allEnterprises: [],
    isLoading: true,
    entityWithDecisionsToShowInfos: null,
  };

  async componentDidMount() {
    const { enterprises: allEnterprises } = await fetchLawFirmEnterprises(
      this.props.lawOfficeIdGroup,
      true,
    );
    this.setState({ allEnterprises, isLoading: false });
  }

  handleClickDecision = (enterprise: Enterprise) => {
    this.setState({
      entityWithDecisionsToShowInfos: {
        name: enterprise.name,
        params: {
          lawOfficeId: this.props.lawOfficeIdGroup,
          siren: enterprise.siren,
        },
      },
    });
    doctrineAnalytics('Entity SeeEntityDecisions', {
      source: `${this.props.source}_modal`,
    });
  };

  handleGoBack = () => {
    this.setState({ entityWithDecisionsToShowInfos: null });
  };

  render() {
    const { name, isOpen, source, wording, onRequestClose } = this.props;
    const {
      isLoading,
      allEnterprises,
      entityWithDecisionsToShowInfos,
    } = this.state;
    return (
      <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
        {entityWithDecisionsToShowInfos ? (
          <EntityDecisionListModalWithGoBack
            entityWithDecisionsToShowInfos={entityWithDecisionsToShowInfos}
            wording={wording}
            closeModal={onRequestClose}
            handleGoBack={this.handleGoBack}
            source={source}
          />
        ) : (
          <>
            <ModalScrollableHeader
              title={`Entreprises représentées par ${name}`}
              onClose={onRequestClose}
            />
            <ModalScrollableContent>
              <EntityModalLoader isLoading={isLoading}>
                <EnterpriseList
                  enterprises={allEnterprises}
                  source={`${source}_modal_list`}
                  wording={wording}
                  handleClickDecision={this.handleClickDecision}
                  fromModal
                />
              </EntityModalLoader>
            </ModalScrollableContent>
          </>
        )}
      </ModalScrollableContainer>
    );
  }
}
